import { render, staticRenderFns } from "./AppraisalDetails.vue?vue&type=template&id=a1a42e54&scoped=true&"
import script from "./AppraisalDetails.vue?vue&type=script&lang=js&"
export * from "./AppraisalDetails.vue?vue&type=script&lang=js&"
import style0 from "./AppraisalDetails.vue?vue&type=style&index=0&id=a1a42e54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a42e54",
  null
  
)

export default component.exports